export const fetchScanDetailsData = async (payload) => {
    //configure api url
    const apiUrl = global.config.premTrackingServiceUrl + "/cargoawbtracking/trackAirWaybillPiecesDetails"
            + "?air-waybill-prefix=" + payload.awbPrefix
            + "&air-waybill-number=" + payload.airWaybillNumber
            + "&air-waybill-create-date=" + payload.isoCreateDate;

    const response = await fetch(apiUrl, {
        method: 'GET',
        headers: {
            'Content-Type': 'application/json',
            'X-API-Key': global.config.apiKey
        }
    });

    if (!response.ok) {
        throw new Error('Something went wrong ...');
    }

    return await response.json();
};

export const fetchShipmentData = async (payload) => {
    //configure api url
    const apiUrl = global.config.trackingServiceUrl + "/cargoawbtracking/trackAirWaybill";

    let request = [];
    const requestItem = {
        prefix: payload.awbPrefix,
        airWaybillNumber: payload.airWaybillNumber
    };
    request.push(requestItem);

    const response = await fetch(apiUrl, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
            'X-API-Key': global.config.apiKey
        },
        body: JSON.stringify(request)
    });

    if (!response.ok) {
        throw new Error(response.statusText);
    }

    const data = await response.json();
    return data;
};



// WEBPACK FOOTER //
// ./src/api/scanDetailsDataApi.js